<script lang="ts">
export default {
  name: 'CustomerLayout',
};
</script>
<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

import AppNavBar from '@/components/app-layouts/AppNavBar.vue';
import AdminSideBar from '@/components/app-layouts/AdminSideBar.vue';
import AppFooter from '@/components/app-layouts/AppFooter.vue';
import LoadingPanel from '../LoadingPanel.vue';

import { ROUTER } from '@/app-constants/router.constant';
import { isAdministrator, isCustomerSuccessManager } from '@/utils/user.utils';
import ChatWidget from '@/components/chat/ChatWidget.vue';

const router = useRouter();

const { hasAuthenticated, getUser } = useAuthStore();
const isAuthenticated = hasAuthenticated();
const authUser = getUser();
const isAdmin = isAdministrator(authUser) || isCustomerSuccessManager(authUser);

onMounted(() => {
  // redirect to Admin home page
  if (!isAdmin) {
    router.push({ path: ROUTER.CUSTOMER.HOME_PAGE.PATH, replace: true });
  }
});
</script>

<template>
  <template v-if="!isAuthenticated || !isAdmin">
    <main class="relative h-full">
      <div class="h-full p-4">
        <LoadingPanel />
      </div>
    </main>
  </template>
  <template v-else>
    <div class="flex flex-col min-h-full">
      <AppNavBar :show-tenant-name="false" />
      <AdminSideBar />
      <main class="relative xl:ml-64 grow flex flex-col justify-between">
        <div class="p-4 xl:pl-5 xl:pr-8">
          <RouterView />
        </div>
        <AppFooter />
      </main>
    </div>
    <ChatWidget />
  </template>
</template>
